import React from 'react';
import { Inline, Text } from '@atlaskit/primitives';
import { useIssueTypeName } from '@atlassian/jira-polaris-component-issue-types/src/controllers/index.tsx';
import type { IssueTypeId } from '@atlassian/jira-shared-types/src/general.tsx';
import { IssueTypeIcon } from '@atlassian/jira-polaris-component-issue-types/src/ui/issue-type-icon/issue-type-icon.tsx';
import type { TriggerType } from './trigger.tsx';

type Props = {
	issueTypeId: IssueTypeId;
	triggerType?: TriggerType;
};

export const IssueTypeSelectReadonlyView = ({ issueTypeId, triggerType = 'icon-only' }: Props) => {
	const issueTypeName = useIssueTypeName({ issueTypeId });

	switch (triggerType) {
		case 'icon-and-name':
			return (
				<Inline alignBlock="center" space="space.050">
					<IssueTypeIcon issueTypeId={issueTypeId} />
					<Text weight="medium">{issueTypeName}</Text>
				</Inline>
			);
		case 'icon-and-chevron':
		default:
			return <IssueTypeIcon issueTypeId={issueTypeId} />;
	}
};
